import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class WhItemsListItem extends SearchModelBase {
    customer: string = '';
    prodCode: string = '';
    itemDesc: string = '';
    upc: string = '';
    boxUnit: string = '';
    innerPac: number|null = null;
    defaultLoc: string = '';
    lbs: number|null = null;
    length: number|null = null;
    width: number|null = null;
    height: number|null = null;
    cft: number|null = null;
    id: number = 0;
    fromInnerPac: number|null = null;
    toInnerPac: number|null = null;
    fromLBS: number|null = null;
    toLBS: number|null = null;
    fromLength: number|null = null;
    toLength: number|null = null;
    fromWidth: number|null = null;
    toWidth: number|null = null;
    fromHeight: number|null = null;
    toHeight: number|null = null;
    fromCFT: number|null = null;
    toCFT: number|null = null;
    u2Date: string | null = null;
    fromU2Date: string | null = null;
    toU2Date: string | null = null;
    u2ID: string = '';
    u1Date: string | null = null;
    fromU1Date: string | null = null;
    toU1Date: string | null = null;
    u1ID: string = '';
    isUsed: number = 0;
    
    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: '', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        XCol.Create({ col: 0, text: 'Company ID', width: 80, dataIndex: 'customer'}),
        XCol.Create({ col: 1, text: 'Prod Code/SKU', width: 120, dataIndex: 'prodCode', defaultColumnFocus : true}),
        XCol.Create({ col: 2, text: 'Description', width: 150, dataIndex: 'itemDesc'}),
        XCol.Create({ col: 3, text: 'UPC/EAN', width: 80, dataIndex: 'upc'}),
        XCol.Create({ col: 4, text: 'Unit', width: 60, dataIndex: 'boxUnit'}),
        XCol.Create({ col: 5, text: 'Inner Pack', width: 80, dataIndex: 'innerPac', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0', noNullOrEmptySearch: true }),
        XCol.Create({ col: 6, text: 'Default Location', width: 80, dataIndex: 'defaultLoc'}),
        XCol.Create({ col: 7, text: 'LBS', width: 80, dataIndex: 'lbs', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 8, text: 'Length', width: 80, dataIndex: 'length', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 9, text: 'Width', width: 80, dataIndex: 'width', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 10, text: 'Height', width: 80, dataIndex: 'height', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 11, text: 'CFT', width: 80, dataIndex: 'cft', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 12, text: 'Create Date', width: 100, dataIndex: 'u1Date', type: XCol.XCellType.DateTime, formatString: '#,##0.00'}),
        XCol.Create({ col: 14, text: 'Create by', width: 80, dataIndex: 'u1ID'}),
        XCol.Create({ col: 12, text: 'Update Date', width: 100, dataIndex: 'u2Date', type: XCol.XCellType.DateTime, formatString: '#,##0.00'}),
        XCol.Create({ col: 13, text: 'Update by', width: 80, dataIndex: 'u2ID'}),
    ];

    
    public static getExportCollection(): XCol.XExportColumn[] {
        return WhItemsListItem.ExportCollection
    };
	
    public static OrderBy = { orderBy: WhItemsListItem.prototype.prodCode, orderByAscending: true };

    public static formatData(data: WhItemsListItem[]) {
        return data.map((d: WhItemsListItem) => ({
          ...d,
        }));
    }

    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        innerPac: {from: 'fromInnerPac', to: 'toInnerPac'},
        lbs: {from: 'fromLBS', to: 'toLBS'},
        length: {from: 'fromLength', to: 'toLength'},
        width: {from: 'fromWidth', to: 'toWidth'},
        height: {from: 'fromHeight', to: 'toHeight'},
        cft: {from: 'fromCFT', to: 'toCFT'},
        u1Date: {from: 'fromU1Date', to: 'toU1Date'},
        u2Date: {from: 'fromU2Date', to: 'toU2Date'},
    }
}
